import script from "./V4MyVideosMain.vue?vue&type=script&setup=true&lang=js"
export * from "./V4MyVideosMain.vue?vue&type=script&setup=true&lang=js"

import "./V4MyVideosMain.vue?vue&type=style&index=0&id=65353b19&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65353b19"]])

export default __exports__